import { type VariantProps, cva } from 'class-variance-authority'
import SheetMain from './SheetMain.vue'

export default SheetMain
export { default as SheetTrigger } from './SheetTrigger.vue'
export { default as SheetContent } from './SheetContent.vue'
export { default as SheetHeader } from './SheetHeader.vue'
export { default as SheetDescription } from './SheetDescription.vue'
export { default as SheetFooter } from './SheetFooter.vue'
export { default as SheetTitle } from './SheetTitle.vue'
export { default as SheetClose } from './SheetClose.vue'

export const sheetVariants = cva(
    'data-[state=open]:animate-in data-[state=closed]:animate-out fixed z-[70] gap-4 bg-plus-lp-background p-6 shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500',
    {
        variants: {
            side: {
                top: 'data-[state=closed]:lp-slide-out-to-top data-[state=open]:lp-slide-in-from-top inset-x-0 top-0 border-b',
                bottom: 'data-[state=closed]:lp-slide-out-to-bottom data-[state=open]:lp-slide-in-from-bottom inset-x-0 bottom-0 border-t',
                left: 'data-[state=closed]:lp-slide-out-to-left data-[state=open]:lp-slide-in-from-left inset-y-0 left-0 h-full w-3/4 border-r sm:max-w-sm',
                right: 'data-[state=closed]:lp-slide-out-to-right data-[state=open]:lp-slide-in-from-right inset-y-0 right-0 size-full border-l md:w-[656px]',
            },
        },
        defaultVariants: {
            side: 'right',
        },
    },
)

export const closeButtonVariants = cva(
    'group absolute right-4 top-4 size-11 rounded-full p-1 transition-colors duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
    {
        variants: {
            theme: {
                light: 'focus-visible:ring-focus fill-dark-blue bg-plus-lp-grey-200 active:bg-plus-lp-grey-300',
                dark: 'focus-visible:ring-focus-light fill-grey-300 bg-plus-lp-white-disabled-bg focus-visible:ring-offset-current',
            },
        },
        defaultVariants: {
            theme: 'light',
        },
    },
)

export type SheetVariants = VariantProps<typeof sheetVariants>

export type CloseButtonVariants = VariantProps<typeof closeButtonVariants>
